export default __webpack_public_path__ + "static/media/upload.da99d8ae.png";